import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";

export class Compass1ChartJS extends AlgoBase {

  constructor(target, csvFileOverride, graphIndex = 1) {
    super("compass", target);
    this.graphIndex = graphIndex;
    this.init(csvFileOverride);
  }

  async init(csvFileOverride) {

    this.algortihmData = await this.buildDataset(csvFileOverride ?? "data/algorithms/Compass1-DryDay.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Heating reset',  // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#EB2B31',
        }, {
          label: 'Cooling reset', // [dynamic value in loadDataset()],
          data: this.algortihmData.allDatasets[1],
          borderColor: '#3729AF',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              box1: {
                type: 'box',
                borderWidth: 0,
                xMin: 0,
                xMax: 23,
                backgroundColor: 'rgba(191, 191, 191, 0.4)',
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'beforeDraw',
                  z: 2,
                  // rotation: -90,
                  content: "Comfort zone", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font
                }
              },
            },
          },
          title: {
            display: true,
            text: '-', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 1),
          y: {
            // min: [dynamic value in loadDataset()],
            // max: [dynamic value in loadDataset()],
            ticks: {
              callback: (value, index, ticks) => {
                return this.temperatureLegend(value); // Append the unit
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());

    // Update data for preferred unit
    this.algortihmData.mainDatasets[datasetIndex + offset] = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[0][datasetIndex + offset])
    this.chart.data.datasets[1].data = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[1][datasetIndex + offset]);

    // Update y limits for preferred unit
    if (this.preferredUnit === "celsius") {
      this.chart.options.scales.y.min = 12
      this.chart.options.scales.y.max = 28
      this.chart.options.plugins.annotation.annotations.box1.yMin = this.fahrenheitToCelsius(this.algortihmData.allDatasets[2][datasetIndex][0]);
      this.chart.options.plugins.annotation.annotations.box1.yMax = this.fahrenheitToCelsius(this.algortihmData.allDatasets[3][datasetIndex][0]);
    } else {
      this.chart.options.scales.y.min = 55
      this.chart.options.scales.y.max = 80
      this.chart.options.plugins.annotation.annotations.box1.yMin = this.algortihmData.allDatasets[2][datasetIndex][0];
      this.chart.options.plugins.annotation.annotations.box1.yMax = this.algortihmData.allDatasets[3][datasetIndex][0];
    }

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, this.graphIndex);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, this.graphIndex);
    this.chart.options.plugins.annotation.annotations.box1.label.content = this.getLegendFromCMS(3, this.graphIndex).toUpperCase();

    this.chart.options.plugins.title.text = this.getLegendFromCMS(4, this.graphIndex)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    return await super.buildDatasetFromCSV(filename, 4);
  }

}
